import { getHTML } from '../../services/helper';
import './ThreeColumnBlock.scss';

interface ICards {
  iconClass?: string;
  header: string;
  description: string;
  bodyClass?: string;
}

interface IProps {
  content: {
    cards: ICards[];
  }
}

const ThreeColumnBlock: React.FC<IProps> = (props: IProps) => {
  return (
    <div className="card-deck">
      {
        props.content.cards.length > 0 &&
        props.content.cards.map((card, index) =>
        <div key={index} className={"card box-custom-shadow-1 card" + (index+1)}>
          <div className={"card-body " + (card.bodyClass)}>
            { card.iconClass &&
              <span className="fa-stack fa-2x">
                <i className="fas fa-circle fa-stack-2x"></i>
                <i className={'fa-stack-1x fas ' + (card.iconClass)}></i>
              </span>
            }
            <h2 className="card-title font28px">{card.header}</h2>
            <p className="card-text text-muted" dangerouslySetInnerHTML={getHTML(card.description || '')}></p>
          </div>
        </div>
        )
      }
  </div>  
  );
}

export default ThreeColumnBlock;
